// @ts-nocheck
(function () {
  'use strict';

  function parseCenter(value) {
    if (!value) return [-1, 54];
    var parts = value.split(',').map(function (part) {
      return parseFloat(part.trim());
    });
    if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) return parts;
    return [-1, 54];
  }

  function flyTo(map, location) {
    if (!map || !location || typeof location.lat !== 'number' || typeof location.lng !== 'number') return;
    map.flyTo({
      center: [location.lng, location.lat],
      zoom: 13,
      essential: true,
      duration: 900
    });
  }

  function scrollListToItem(root, item) {
    var list = root.querySelector('[data-location-finder-list]');
    if (!list || !item) return;
    var listRect = list.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var offset = itemRect.top - listRect.top + list.scrollTop - 12;
    list.scrollTo({ top: offset, behavior: 'smooth' });
  }

  function setItemExpanded(item, expanded) {
    if (!item) return;
    var trigger = item.querySelector('.location-finder-item__trigger');
    var panel = item.querySelector('.location-finder-item__panel');
    item.setAttribute('data-expanded', expanded ? 'true' : 'false');
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (panel) panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
  }

  function expandItem(root, item) {
    if (!item) return;
    root.querySelectorAll('[data-location-finder-item][data-expanded="true"]').forEach(function (other) {
      if (other === item) return;
      setItemExpanded(other, false);
    });
    setItemExpanded(item, true);
  }

  function getMarkerIconHtml(root) {
    var template = root.querySelector('.location-finder__marker-template');
    return template ? template.innerHTML.trim() : '';
  }

  function createMarkerElement(root, location) {
    var element = document.createElement('button');
    var iconHtml = getMarkerIconHtml(root);
    element.type = 'button';
    element.className = 'location-finder__marker';
    element.setAttribute('aria-label', location.name);
    element.dataset.locationHandle = location.handle;
    element.innerHTML = iconHtml
      ? '<span class="location-finder__marker-icon">' + iconHtml + '</span>'
      : '';
    return element;
  }

  function initFinder(root) {
    if (!root || root.dataset.locationFinderInitialised === 'true') return;
    var dataEl = root.querySelector('[data-location-finder-data]');
    if (!dataEl) return;

    var token = root.dataset.mapboxToken;
    var styleUrl = root.dataset.mapboxStyle;
    var mapEl = root.querySelector('[data-location-finder-map]');
    if (!token || !mapEl || !window.mapboxgl) return;

    var locations = [];
    try {
      locations = JSON.parse(dataEl.textContent);
      if (!Array.isArray(locations)) locations = [];
    } catch (error) {
      return;
    }

    var byHandle = {};
    locations.forEach(function (location) {
      byHandle[location.handle] = location;
    });
    var withCoords = locations.filter(function (location) {
      return typeof location.lng === 'number' && typeof location.lat === 'number';
    });

    while (mapEl.firstChild) mapEl.removeChild(mapEl.firstChild);
    var placeholder = root.querySelector('.location-finder__map-placeholder');
    if (placeholder) placeholder.style.display = 'none';

    var defaultCenter = parseCenter(root.dataset.mapCenter);
    var defaultZoom = 10;

    window.mapboxgl.accessToken = token;
    var map = new window.mapboxgl.Map({
      container: mapEl,
      style: styleUrl || 'mapbox://styles/mapbox/light-v11',
      center: defaultCenter,
      zoom: defaultZoom,
      attributionControl: { compact: true }
    });

    map.addControl(new window.mapboxgl.NavigationControl({ showCompass: false }), 'top-right');

    var initialBounds = null;
    map.on('load', function () {
      var bounds = new window.mapboxgl.LngLatBounds();
      withCoords.forEach(function (location) {
        var marker = createMarkerElement(root, location);
        new window.mapboxgl.Marker({ element: marker, anchor: 'center' })
          .setLngLat([location.lng, location.lat])
          .addTo(map);
        bounds.extend([location.lng, location.lat]);
      });
      if (!bounds.isEmpty()) {
        initialBounds = bounds;
        map.fitBounds(bounds, { padding: 48, maxZoom: 10, duration: 0 });
      }
    });

    root.dataset.locationFinderInitialised = 'true';

    function highlightMarker(handle) {
      root.querySelectorAll('.location-finder__marker').forEach(function (marker) {
        marker.classList.toggle('location-finder__marker--active', marker.dataset.locationHandle === handle);
      });
    }

    root.addEventListener('click', function (event) {
      var marker = event.target.closest('.location-finder__marker');
      if (marker) {
        var handle = marker.dataset.locationHandle;
        var item = root.querySelector('[data-location-finder-item][data-handle="' + handle + '"]');
        if (item) {
          expandItem(root, item);
          scrollListToItem(root, item);
        }
        flyTo(map, byHandle[handle]);
        highlightMarker(handle);
        return;
      }

      var trigger = event.target.closest('.location-finder-item__trigger');
      if (!trigger) return;
      var itemEl = trigger.closest('[data-location-finder-item]');
      if (!itemEl) return;
      var willExpand = itemEl.getAttribute('data-expanded') !== 'true';

      if (willExpand) {
        expandItem(root, itemEl);
        flyTo(map, byHandle[itemEl.dataset.handle]);
        highlightMarker(itemEl.dataset.handle);
      } else {
        setItemExpanded(itemEl, false);
        highlightMarker(null);
        if (initialBounds && !initialBounds.isEmpty()) {
          map.fitBounds(initialBounds, { padding: 48, maxZoom: 10, duration: 700 });
        }
      }
    });
  }

  function ensureMapboxAndInit() {
    var roots = document.querySelectorAll('[data-location-finder]');
    if (!roots.length) return;
    if (window.mapboxgl) {
      roots.forEach(initFinder);
      return;
    }
    var existing = document.querySelector('script[data-mapbox-gl]');
    if (existing) {
      existing.addEventListener('load', function () {
        roots.forEach(initFinder);
      });
      return;
    }
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://api.mapbox.com/mapbox-gl-js/v3.6.0/mapbox-gl.css';
    document.head.appendChild(css);
    var js = document.createElement('script');
    js.src = 'https://api.mapbox.com/mapbox-gl-js/v3.6.0/mapbox-gl.js';
    js.dataset.mapboxGl = 'true';
    js.async = true;
    js.addEventListener('load', function () {
      roots.forEach(initFinder);
    });
    document.head.appendChild(js);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureMapboxAndInit);
  } else {
    ensureMapboxAndInit();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-location-finder]')) {
      ensureMapboxAndInit();
    }
  });
})();
